import { InputContainer } from "@ui/InputContainer";
import { InputError } from "@ui/InputError";
import { Stack } from "@ui/Stack";
import { Text } from "@ui/typography/Text";
import type { Accessor } from "solid-js";
import { Show } from "solid-js";
import type { SetStoreFunction, Store } from "solid-js/store";
import { IconPicker } from "~/modules/agencyhub/groups/components/IconPicker";
import { PrivacyRadioGroup } from "../../shared/PrivacyRadioGroup";
import type { AddBoardFormData } from "./NewBoardButton";

type Props = {
	formData: Store<AddBoardFormData>;
	setFormData: SetStoreFunction<AddBoardFormData>;
	errors: Accessor<Record<string, string[]>>;
	showPrivacy?: boolean;
};

export const AddBoardForm = (props: Props) => {
	const { formData, setFormData, errors } = props;
	return (
		<form
			onSubmit={(e) => {
				e.preventDefault();
			}}
		>
			<Stack direction="column" spacing="medium">
				<InputContainer>
					<label for="board-title">Board name</label>
					<input
						type="text"
						id="board-title"
						value={formData.title}
						onInput={(e) => {
							setFormData("title", (e.target as HTMLInputElement).value);
						}}
						name="title"
					/>
					<InputError name="title" errors={errors} />
				</InputContainer>
				<InputContainer>
					<label for="board-description">
						<div>
							Description{" "}
							<Text color="fg3" size="small" as="span">
								(optional)
							</Text>
						</div>
					</label>
					<textarea
						id="board-description"
						value={formData.description}
						onInput={(e) => {
							setFormData(
								"description",
								(e.target as HTMLTextAreaElement).value,
							);
						}}
						placeholder="Enter board description"
						rows={4}
					/>
				</InputContainer>
				<IconPicker
					value={formData.icon}
					onChange={(icon) => {
						setFormData("icon", icon);
					}}
				/>
				<Show when={props.showPrivacy}>
					<PrivacyRadioGroup
						value={formData.privacy}
						onChange={(value) => {
							setFormData("privacy", value);
						}}
					/>
				</Show>
			</Stack>
		</form>
	);
};
